import React from "react";

import { getZendeskTicketUrl } from "../../../../../../../constants/endpoints";
import { getDateFormat } from "../../../../../../../common/date-format";
import { API_NAMES } from "../../EVisa/constants/apiNames";
import { capitalizeEachWord } from "../../../../../../../utils";
import { Checkbox } from "semantic-ui-react";
import env from "../../../../../../../env";
import { isApplicantSelected, selectApplicant } from "../../../../../../../utils";
import { renderApplicationType } from "./fastTrackUtils";

export const columns = {
  checkBox: {
    label: "checkbox",
    value: (applicant, selectedApplicants, setSelectedApplicants) => { 
      return (
        <Checkbox
          disabled={
            selectedApplicants.length >= env.PASSPORT_GENERATE_MAX_COUNT &&
            !selectedApplicants.includes(applicant._id)
          }
          checked={isApplicantSelected(selectedApplicants, applicant)}
          onChange={() => {selectApplicant(selectedApplicants, applicant, setSelectedApplicants)}}
        />
      );
    },
  },
  fullName: {
    label: "Name",
    value: (applicant) =>
      capitalizeEachWord(
        `${applicant.firstName || ""} ${applicant.lastName || ""}`,
      ),
  },
  userEmail: {
    label: "Email",
  },
  _id: {
    label: "ID",
    value: (applicant, zendeskView) => {
      return (
        <a
          href={`/${API_NAMES.DS11}/applicant/${applicant._id}`}
          target={zendeskView ? "" : "_blank"}
          rel="noopener noreferrer"
        >
          {applicant._id}
        </a>
      );
    },
  },
  birthDate: {
    label: "Birth date",
    value: (applicant) => getDateFormat(applicant.birthDate, null, "DD/MM/YYYY"),
  },
  applicationType: {
    label: "Type",
    value: renderApplicationType,
  },
  createdAt: {
    label: "Created at",
    value: (applicant) => getDateFormat(applicant.createdAt),
  },
  paymentStatus: {
    label: "Payment status",
  },
  status: {
    label: "Status",
  },
  siteId: {
    label: "Site ID",
    value: (applicant) => applicant.siteId,
  },
  zendeskId: {
    label: "Zendesk ID",
    value: (applicant) => (
      <a
        href={getZendeskTicketUrl(applicant.zendeskId, applicant.zendeskInstance)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {applicant.zendeskId}
      </a>
    ),
  },
};
